import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';
import { useTranslation } from 'react-i18next';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (url: string) => {
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div ref={dropdownRef} className="relative w-full max-w-md mx-auto" id="categories">
      <label className="block text-sm font-medium text-foreground-700 mb-2 text-center">
        {t('categoryDropdownLabel')}
      </label>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-white border border-background-200 rounded-xl text-sm text-foreground-800 hover:border-primary-300 focus:outline-none focus:ring-2 focus:ring-primary-200 transition-all duration-200 cursor-pointer"
      >
        <span className="text-foreground-600">
          Escolha uma categoria...
        </span>
        {isOpen ? (
          <i className="ri-arrow-up-s-line text-foreground-500 text-lg"></i>
        ) : (
          <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
        )}
      </button>

      {isOpen && (
        <div className="absolute z-40 mt-2 w-full max-h-72 overflow-y-auto bg-white border border-background-200 rounded-xl shadow-lg">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleSelect(cat.url)}
              className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-50 hover:text-primary-600 transition-colors duration-150 text-left cursor-pointer border-b border-background-100 last:border-b-0"
            >
              <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className={`${cat.icon} text-base`}></i>
              </span>
              <span>{cat.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}